<div class="modal">
  <h3 class="title">{{ titleLabel }}</h3>
  <div class="content">
    <p *ngFor="let text of paragraphLabels">{{ text }}</p>
  </div>
  <div class="actions">
    <app-btn (click)="onClickNegative()">{{ negativeActionLabel }}</app-btn>
    <app-btn (click)="onClickPositive()">{{ positiveActionLabel }}</app-btn>
  </div>
</div>
